export default "__VITE_ASSET__D4VD2L$9__"